module.exports = "<div class=row> <div class=col-xs-3> <div class=form-group> <app-widgets-label i18n-label=Subtype></app-widgets-label> <p class=form-control-static>{{ poi.marking_point_type | appTranslateEnum:'marking_point_type' }}</p> </div> </div> </div> <ng-include src=\"'app/poi/view/general/partial_descriptions.html'\"></ng-include> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/view/general/partial_marking_point.html
// module id = 454
// module chunks = 0